
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $b179ad693870b513$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["d0cGV","bi_quyet_giup_con_het_nghien_game_tu_chuyen_gia_Nguyen_Thi_Lanh.70b8ac06.js","dP853","V\xf4-t\xecnh-g\xe2y-t\u1ED5n-th\u01B0\u01A1ng-cho-con-nhi\u1EC1u-n\u0103m-m\xe0-cha-m\u1EB9-kh\xf4ng-bi\u1EBFt.36d6256e.jpg","gYbsp","Ng\u01B0\u1EDDi-cha-n\xf3ng-t\xednh-v\xe0-h\xe0nh-tr\xecnh-ch\u1EEFa-l\xe0nh-c\u1EA3m-x\xfac.a493fca5.png","OeIFs","C\u01A1n-gi\u1EADn-c\u1EE7a-m\u1EB9-l\xe0-t\u1ED5n-th\u01B0\u01A1ng-c\u1EE7a-con.f92cf7e9.png","amgru","Tu\u1ED5i-d\u1EADy-th\xec-v\xe0-s\u1EF1-b\u1EA5t-l\u1EF1c-t\u1EEB-ng\u01B0\u1EDDi-m\u1EB9.69df3d8c.png","7RqAu","S\u1ED1ng-m\u1EA5t-ph\u01B0\u01A1ng-h\u01B0\u1EDBng-L\xe3nh-c\u1EA3m-v\u1EDBi-ch\u1ED3ng-M\u1EA5t-k\u1EBFt-n\u1ED1i-v\u1EDBi-con.8c009f40.png","2shjI","M\u1EB9-\xe1p-\u0111\u1EB7t-l\xe0m-t\u1ED5n-th\u01B0\u01A1ng-con.d475535f.png","eOlXL","M\u1EB9-Ch\xednh-L\xe0-Ni\u1EC1m-T\u1EF1-H\xe0o-C\u1EE7a-Con!.b32ac4a0.png","i40W5","Thumb-K1.cb6e4626.jpg","f005e","Thumb-K2.e77f7e2c.jpg","ivwvk","Thumb-K3.3e9e0992.jpg"]'));

const $f7fca9471e720bd1$var$map = L.map("map").setView([
    21.17128044628222,
    106.06725264262127
], 50);
L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
    attribution: "\xa9 OpenStreetMap contributors"
}).addTo($f7fca9471e720bd1$var$map);
const $f7fca9471e720bd1$var$specificLocation = [
    21.17128044628222,
    106.06725264262127
];
L.marker($f7fca9471e720bd1$var$specificLocation).addTo($f7fca9471e720bd1$var$map).bindPopup("Parkview City - Dabaco Huy\u1EC1n Quang").openPopup();
var $22dd8badae9d2278$exports = {};
$22dd8badae9d2278$exports = new URL("V\xf4-t\xecnh-g\xe2y-t\u1ED5n-th\u01B0\u01A1ng-cho-con-nhi\u1EC1u-n\u0103m-m\xe0-cha-m\u1EB9-kh\xf4ng-bi\u1EBFt.36d6256e.jpg", import.meta.url).toString();


const $f7fca9471e720bd1$var$img1 = new URL($22dd8badae9d2278$exports);
var $241bdf61099805cd$exports = {};
$241bdf61099805cd$exports = new URL("Ng\u01B0\u1EDDi-cha-n\xf3ng-t\xednh-v\xe0-h\xe0nh-tr\xecnh-ch\u1EEFa-l\xe0nh-c\u1EA3m-x\xfac.a493fca5.png", import.meta.url).toString();


const $f7fca9471e720bd1$var$img2 = new URL($241bdf61099805cd$exports);
var $72dfbd7963f65b53$exports = {};
$72dfbd7963f65b53$exports = new URL("C\u01A1n-gi\u1EADn-c\u1EE7a-m\u1EB9-l\xe0-t\u1ED5n-th\u01B0\u01A1ng-c\u1EE7a-con.f92cf7e9.png", import.meta.url).toString();


const $f7fca9471e720bd1$var$img3 = new URL($72dfbd7963f65b53$exports);
var $fc3b0a0d939277f2$exports = {};
$fc3b0a0d939277f2$exports = new URL("Tu\u1ED5i-d\u1EADy-th\xec-v\xe0-s\u1EF1-b\u1EA5t-l\u1EF1c-t\u1EEB-ng\u01B0\u1EDDi-m\u1EB9.69df3d8c.png", import.meta.url).toString();


const $f7fca9471e720bd1$var$img4 = new URL($fc3b0a0d939277f2$exports);
var $d1c18849c009b1ac$exports = {};
$d1c18849c009b1ac$exports = new URL("S\u1ED1ng-m\u1EA5t-ph\u01B0\u01A1ng-h\u01B0\u1EDBng-L\xe3nh-c\u1EA3m-v\u1EDBi-ch\u1ED3ng-M\u1EA5t-k\u1EBFt-n\u1ED1i-v\u1EDBi-con.8c009f40.png", import.meta.url).toString();


const $f7fca9471e720bd1$var$img5 = new URL($d1c18849c009b1ac$exports);
var $6025c4a57ec45ef3$exports = {};
$6025c4a57ec45ef3$exports = new URL("M\u1EB9-\xe1p-\u0111\u1EB7t-l\xe0m-t\u1ED5n-th\u01B0\u01A1ng-con.d475535f.png", import.meta.url).toString();


const $f7fca9471e720bd1$var$img6 = new URL($6025c4a57ec45ef3$exports);
var $668cb4a97155af49$exports = {};
$668cb4a97155af49$exports = new URL("M\u1EB9-Ch\xednh-L\xe0-Ni\u1EC1m-T\u1EF1-H\xe0o-C\u1EE7a-Con!.b32ac4a0.png", import.meta.url).toString();


const $f7fca9471e720bd1$var$img7 = new URL($668cb4a97155af49$exports);
var $891daca549685170$exports = {};
$891daca549685170$exports = new URL("Thumb-K1.cb6e4626.jpg", import.meta.url).toString();


const $f7fca9471e720bd1$var$thumbK1 = new URL($891daca549685170$exports);
var $f1a051f65d331ecd$exports = {};
$f1a051f65d331ecd$exports = new URL("Thumb-K2.e77f7e2c.jpg", import.meta.url).toString();


const $f7fca9471e720bd1$var$thumbK2 = new URL($f1a051f65d331ecd$exports);
var $6c27dc1ba77b8f06$exports = {};
$6c27dc1ba77b8f06$exports = new URL("Thumb-K3.3e9e0992.jpg", import.meta.url).toString();


const $f7fca9471e720bd1$var$thumbK3 = new URL($6c27dc1ba77b8f06$exports);
const $f7fca9471e720bd1$var$slideContentExperience = [
    {
        title: "Tu\u1ED5i d\u1EADy th\xec v\xe0 s\u1EF1 b\u1EA5t l\u1EF1c t\u1EEB ng\u01B0\u1EDDi m\u1EB9",
        description: `
          Trong m\u{1ED9}t ng\xf4i nh\xe0 nh\u{1ECF}, t\xecnh y\xeau t\u{1EEB}ng \u{111}\u{1B0}\u{1EE3}c nu\xf4i d\u{1B0}\u{1EE1}ng b\u{1EB1}ng nh\u{1EEF}ng b\u{1EEF}a c\u{1A1}m \u{1EA5}m \xe1p v\xe0 n\u{1EE5} c\u{1B0}\u{1EDD}i r\u{1EA1}ng r\u{1EE1}. Ng\u{1B0}\u{1EDD}i m\u{1EB9}, v\u{1EDB}i tr\xe1i tim r\u{1ED9}ng l\u{1EDB}n v\xe0 \u{111}\xf4i b\xe0n tay \u{111}\xe3 t\u{1EEB}ng ngh\u{129} r\u{1EB1}ng m\xecnh c\xf3 th\u{1EC3} che ch\u{1EDF} v\xe0 b\u{1EA3}o v\u{1EC7} t\u{1EA5}t c\u{1EA3} nh\u{1EEF}ng \u{111}\u{1EE9}a con m\xecnh y\xeau th\u{1B0}\u{1A1}ng, d\xf9 cho kh\xf4ng ph\u{1EA3}i c\xf9ng chung d\xf2ng m\xe1u.<br />
  Nh\u{1B0}ng th\u{1EDD}i gian tr\xf4i \u{111}i, s\xe1u \u{111}\u{1EE9}a con nu\xf4i ng\xe0y n\xe0o gi\u{1EDD} \u{111}\xe3 tr\u{1B0}\u{1EDF}ng th\xe0nh, v\xe0 theo c\xe1ch c\u{1EE7}a ri\xeang m\xecnh, h\u{1ECD} \u{111}ang d\u{1EA7}n r\u{1EDD}i xa. C\u{103}n nh\xe0 ng\xe0y tr\u{1B0}\u{1EDB}c t\u{1EEB}ng tr\xe0n ng\u{1EAD}p ti\u{1EBF}ng c\u{1B0}\u{1EDD}i, gi\u{1EDD} \u{111}\xe2y tr\u{1EDF} n\xean y\xean l\u{1EB7}ng \u{111}\u{1EBF}n ngh\u{1EB9}n ng\xe0o.<br />
  D\xf9 kho\u{1EA3}ng c\xe1ch c\xf3 l\u{1EDB}n d\u{1EA7}n, m\u{1EB9} v\u{1EAB}n tin r\u{1EB1}ng t\xecnh y\xeau c\u{1EE7}a m\u{1ED9}t ng\u{1B0}\u{1EDD}i m\u{1EB9} c\xf3 th\u{1EC3} h\xe0n g\u{1EAF}n m\u{1ECD}i v\u{1EBF}t th\u{1B0}\u{1A1}ng. \u{110}\xf4i khi, ng\u{1B0}\u{1EDD}i m\u{1EB9} ph\u{1EA3}i bi\u{1EBF}t ch\u{1EDD} \u{111}\u{1EE3}i, hy v\u{1ECD}ng, v\xe0 ti\u{1EBF}p t\u{1EE5}c y\xeau, ngay c\u{1EA3} khi nh\u{1EEF}ng \u{111}\u{1EE9}a con \u{111}ang b\u{1EAD}n r\u{1ED9}n \u{111}i t\xecm con \u{111}\u{1B0}\u{1EDD}ng c\u{1EE7}a ri\xeang m\xecnh trong cu\u{1ED9}c s\u{1ED1}ng r\u{1ED9}ng l\u{1EDB}n v\xe0 \u{111}\u{1EA7}y nh\u{1EEF}ng kh\xf3 kh\u{103}n!
        `,
        videoSrc: "https://cdn.nguyenthilanh.com.vn/resources/landing-page/L\u01AF\u01A0NG HU\u1EF2NH KH\u1EA2 \xc1I.mp4",
        thumb: $f7fca9471e720bd1$var$img4
    },
    {
        title: "V\xf4 t\xecnh g\xe2y t\u1ED5n th\u01B0\u01A1ng cho con nhi\u1EC1u n\u0103m m\xe0 cha m\u1EB9 kh\xf4ng bi\u1EBFt",
        description: `
          "\xd4i! M\xecnh \u{111}\xe3 v\xf4 t\xecnh khi\u{1EBF}n con m\xecnh t\u{1ED5}n th\u{1B0}\u{1A1}ng..."<br />
  \u{110}\xe2y l\xe0 l\u{1EDD}i th\xfa nh\u{1EAD}n \u{111}\u{1EA7}y x\xf3t xa c\u{1EE7}a c\xf4 \u{110}\u{1ED7} Th\u{1ECB} Thu Chi\u{1EBF}n - \u{111}\u{1EBF}n t\u{1EEB} H\u{1ED3} Ch\xed Minh, khi nh\u{1EDB} l\u{1EA1}i kho\u{1EA3}ng th\u{1EDD}i gian t\u{1B0}\u{1EDF}ng ch\u{1EEB}ng nh\u{1B0} kh\xf4ng th\u{1EC3} n\xe0o g\u{1EE1} r\u{1ED1}i \u{111}\u{1B0}\u{1EE3}c m\u{1ED1}i quan h\u{1EC7} v\u{1EDB}i con trai l\u{1EDB}n c\u{1EE7}a m\xecnh.<br />
  Hai m\u{1EB9} con ng\xe0y c\xe0ng kh\xf3 tr\xf2 chuy\u{1EC7}n, kh\xf4ng kh\xed l\xfac n\xe0o c\u{169}ng c\u{103}ng th\u{1EB3}ng. C\u{1EA3}m gi\xe1c b\u{1EF1}c b\u{1ED9}i, th\u{1EA5}t v\u{1ECD}ng c\u{1EE9} ch\u{1EA5}t ch\u{1EE9}a trong l\xf2ng, l\xe0m cho kho\u{1EA3}ng c\xe1ch gi\u{1EEF}a h\u{1ECD} c\xe0ng th\xeam xa c\xe1ch.<br />
  C\xf4 Chi\u{1EBF}n t\u{1EEB}ng kh\xf4ng hi\u{1EC3}u t\u{1EA1}i sao m\u{1ECD}i th\u{1EE9} l\u{1EA1}i tr\u{1EDF} n\xean nh\u{1B0} v\u{1EAD}y, cho \u{111}\u{1EBF}n khi c\xf4 t\xecm ra l\u{1EDD}i gi\u{1EA3}i \u{111}\xe1p t\u{1EEB} nh\u{1EEF}ng ki\u{1EBF}n th\u{1EE9}c m\xe0 c\xf4 Lanh chia s\u{1EBB}. Nh\u{1EEF}ng g\xec c\xf4 kh\xe1m ph\xe1 \u{111}\u{1B0}\u{1EE3}c \u{111}\xe3 khi\u{1EBF}n c\xf4 gi\u{1EAD}t m\xecnh nh\u{1EAD}n ra nguy\xean nh\xe2n s\xe2u xa c\u{1EE7}a v\u{1EA5}n \u{111}\u{1EC1} l\xe0 \u{111}i\u{1EC1}u m\xe0 c\xf4 ch\u{1B0}a t\u{1EEB}ng ngh\u{129} \u{111}\u{1EBF}n.
        `,
        videoSrc: "https://cdn.nguyenthilanh.com.vn/resources/landing-page/\u0110\u1ED6 TH\u1ECA THU CHI\u1EBEN.mp4",
        thumb: $f7fca9471e720bd1$var$img1
    },
    {
        title: "Ng\u01B0\u1EDDi cha n\xf3ng t\xednh v\xe0 h\xe0nh tr\xecnh ph\xe1t tri\u1EC3n nh\u1EADn th\u1EE9c c\u1EA3m x\xfac",
        description: `
          Anh Phan Ho\xe0ng Nh\u{1EAB}n - ng\u{1B0}\u{1EDD}i t\u{1EEB}ng ch\xecm \u{111}\u{1EAF}m trong nh\u{1EEF}ng suy ngh\u{129} ti\xeau c\u{1EF1}c, lu\xf4n ph\xe1n x\xe9t m\u{1ECD}i v\u{1EA5}n \u{111}\u{1EC1} trong c\xf4ng vi\u{1EC7}c v\xe0 cu\u{1ED9}c s\u{1ED1}ng, d\u{1EC5} n\xf3ng n\u{1EA3}y, hay c\xe1u g\u{1EAF}t v\xf4 c\u{1EDB} v\u{1EDB}i v\u{1EE3} con. D\xf9 khao kh\xe1t nu\xf4i d\u{1EA1}y con \u{111}\xfang c\xe1ch, nh\u{1B0}ng anh v\u{1EAB}n kh\xf4ng tho\xe1t kh\u{1ECF}i v\xf2ng xo\xe1y c\u{1EE7}a nh\u{1EEF}ng c\u{1EA3}m x\xfac ti\xeau c\u{1EF1}c, li\xean t\u{1EE5}c l\xe0m t\u{1ED5}n th\u{1B0}\u{1A1}ng nh\u{1EEF}ng ng\u{1B0}\u{1EDD}i th\xe2n m\xe0 ch\xednh anh h\u{1EBF}t m\u{1EF1}c y\xeau th\u{1B0}\u{1A1}ng.<br />
  Trong anh lu\xf4n \u{111}au \u{111}\xe1u m\u{1ED9}t c\xe2u h\u{1ECF}i: "T\u{1EA1}i sao m\xecnh y\xeau th\u{1B0}\u{1A1}ng gia \u{111}\xecnh \u{111}\u{1EBF}n th\u{1EBF}, nh\u{1B0}ng l\u{1EA1}i lu\xf4n khi\u{1EBF}n h\u{1ECD} \u{111}au l\xf2ng, xa c\xe1ch?"
  H\xe0nh tr\xecnh thay \u{111}\u{1ED5}i c\u{1EE7}a anh Nh\u{1EAB}n b\u{1EAF}t \u{111}\u{1EA7}u t\u{1EEB} ch\xednh kho\u{1EA3}nh kh\u{1EAF}c anh \u{111}\u{1ED1}i di\u{1EC7}n v\u{1EDB}i c\xe2u h\u{1ECF}i \u{1EA5}y. \u{110}\u{1EBF}n v\u{1EDB}i c\xf4 Lanh v\xe0 Minh Tr\xed Th\xe0nh, anh \u{111}\xe3 t\xecm th\u{1EA5}y con \u{111}\u{1B0}\u{1EDD}ng gi\xfap b\u{1EA3}n th\xe2n th\u{1EE9}c t\u{1EC9}nh. H\xe0nh tr\xecnh Ki\u{1EBF}n t\u{1EA1}o offline th\xe1ng 10 v\u{1EEB}a qua t\u{1EA1}i H\xe0 N\u{1ED9}i \u{111}\xe3 m\u{1EDF} ra cho anh v\xe0 gia \u{111}\xecnh m\u{1ED9}t b\u{1B0}\u{1EDB}c ngo\u{1EB7}t m\u{1EDB}i. Nh\u{1EEF}ng thay \u{111}\u{1ED5}i \u{111}\xe3 d\u{1EA7}n xu\u{1EA5}t hi\u{1EC7}n, t\u{1EEB}ng h\xe0nh \u{111}\u{1ED9}ng nh\u{1ECF} \u{111}\u{1B0}\u{1EE3}c th\u{1EF1}c hi\u{1EC7}n h\xe0ng ng\xe0y v\u{1EDB}i t\xecnh y\xeau th\u{1B0}\u{1A1}ng v\xe0 nh\u{1EAD}n th\u{1EE9}c s\xe2u s\u{1EAF}c h\u{1A1}n.
        `,
        videoSrc: "https://cdn.nguyenthilanh.com.vn/resources/landing-page/HO\xc0NG NH\u1EAAN.mp4",
        thumb: $f7fca9471e720bd1$var$img2
    },
    {
        title: "C\u01A1n gi\u1EADn c\u1EE7a m\u1EB9 l\xe0m t\u1ED5n th\u01B0\u01A1ng con",
        description: `
          \u{201C}L\u{1EA7}n \u{111}\u{1EA7}u ti\xean m\xecnh bi\u{1EBF}t n\xf3i nh\u{1EEF}ng l\u{1EDD}i y\xeau th\u{1B0}\u{1A1}ng, xin l\u{1ED7}i v\u{1EDB}i con.\u{201D}
  \u{110}\xf3 l\xe0 l\u{1EDD}i t\xe2m s\u{1EF1} \u{111}\u{1EA7}y x\xfac \u{111}\u{1ED9}ng c\u{1EE7}a ch\u{1ECB} Li\xean khi \u{111}\u{1EBF}n v\u{1EDB} h\xe0nh tr\xecnh "Ki\u{1EBF}n T\u{1EA1}o Cu\u{1ED9}c \u{110}\u{1EDD}i M\u{1EDB}i - \u{110}\u{1B0}\u{1EDD}ng V\u{1EC1} H\u{1EA1}nh Ph\xfac" K3.<br />
  Tr\u{1B0}\u{1EDB}c \u{111}\xe2y, v\u{1EDB}i n\u{1ED7}i lo con c\xe1i \u{111}\u{1EBF}n tu\u{1ED5}i d\u{1EAD}y th\xec s\u{1EBD} h\u{1ECD}c theo nh\u{1EEF}ng th\xf3i h\u{1B0} v\xe0 h\xe0nh vi ch\u{1B0}a t\u{1ED1}t c\u{1EE7}a nhau, ch\u{1ECB} Li\xean \u{111}\xe3 nhi\u{1EC1}u l\u{1EA7}n kh\xf4ng ki\u{1EC1}m ch\u{1EBF} \u{111}\u{1B0}\u{1EE3}c c\u{1EA3}m x\xfac, hay n\u{1ED5}i n\xf3ng v\xe0 d\u{1EA1}y con b\u{1EB1}ng \u{111}\xf2n roi. Ch\u{1ECB} tin r\u{1EB1}ng c\xe1ch d\u{1EA1}y con n\xe0y s\u{1EBD} gi\xfap con hi\u{1EC3}u nhanh v\xe0 ngoan h\u{1A1}n. Th\u{1EBF} nh\u{1B0}ng, sau m\u{1ED7}i l\u{1EA7}n nh\u{1B0} v\u{1EAD}y, ch\u{1ECB} l\u{1EA1}i c\u{1EA3}m th\u{1EA5}y kho\u{1EA3}ng c\xe1ch gi\u{1EEF}a m\xecnh v\xe0 con ng\xe0y m\u{1ED9}t xa d\u{1EA7}n.<br />
  M\xe3i cho \u{111}\u{1EBF}n khi bi\u{1EBF}t \u{111}\u{1EBF}n c\xf4 Lanh v\xe0 Minh Tr\xed Th\xe0nh, l\u{1EAF}ng nghe nh\u{1EEF}ng ki\u{1EBF}n th\u{1EE9}c c\xf4 chia s\u{1EBB} ch\u{1ECB} Li\xean m\u{1EDB}i d\u{1EA7}n nh\u{1EAD}n ra r\u{1EB1}ng nh\u{1EEF}ng c\xe1ch d\u{1EA1}y con tr\u{1B0}\u{1EDB}c \u{111}\xe2y \u{111}\xe1ng k\u{1EC3} l\xe0 c\xe1ch nu\xf4i d\u{1EA1}y c\u{1EE7}a nh\u{1EEF}ng cha m\u{1EB9} \u{201C}\u{111}\u{1ED9}c h\u{1EA1}i\u{201D}. Hi\u{1EC3}u \u{111}\u{1B0}\u{1EE3}c \u{111}i\u{1EC1}u \u{111}\xf3, ch\u{1ECB} b\u{1EAF}t \u{111}\u{1EA7}u h\xe0nh tr\xecnh thay \u{111}\u{1ED5}i b\u{1EA3}n th\xe2n. T\u{1EEB} nh\u{1EEF}ng h\xe0nh \u{111}\u{1ED9}ng nh\u{1ECF} h\u{1EB1}ng ng\xe0y, ch\u{1ECB} h\u{1ECD}c c\xe1ch ki\u{1EC1}m ch\u{1EBF}, l\u{1EAF}ng nghe, v\xe0 chia s\u{1EBB} \u{111}\u{1EC3} tr\u{1EDF} th\xe0nh m\u{1ED9}t ng\u{1B0}\u{1EDD}i m\u{1EB9} th\u{1EA5}u hi\u{1EC3}u v\xe0 d\u{1EAB}n d\u{1EAF}t con b\u{1EB1}ng t\xecnh y\xeau th\u{1B0}\u{1A1}ng th\u{1EF1}c s\u{1EF1}.
        `,
        videoSrc: "https://cdn.nguyenthilanh.com.vn/resources/landing-page/HO\xc0NG TH\u1ECA KIM LI\xcaN.mp4",
        thumb: $f7fca9471e720bd1$var$img3
    },
    {
        title: "S\u1ED1ng m\u1EA5t ph\u01B0\u01A1ng h\u01B0\u1EDBng - L\xe3nh c\u1EA3m v\u1EDBi ch\u1ED3ng - M\u1EA5t k\u1EBFt n\u1ED1i v\u1EDBi con",
        description: `
          Sau nhi\u{1EC1}u n\u{103}m h\xf4n nh\xe2n, ch\u{1ECB} Huy\u{1EC1}n d\u{1EA7}n \u{111}\xe1nh m\u{1EA5}t s\u{1EF1} k\u{1EBF}t n\u{1ED1}i v\u{1EDB}i ch\u{1ED3}ng v\xe0 con g\xe1i \u{2013} nh\u{1EEF}ng ng\u{1B0}\u{1EDD}i ch\u{1ECB} y\xeau th\u{1B0}\u{1A1}ng nh\u{1EA5}t. T\u{1EEB} m\u{1ED9}t gia \u{111}\xecnh h\u{1EA1}nh ph\xfac, gi\u{1EDD} ch\u{1EC9} c\xf2n l\xe0 m\u{1ED9}t gia \u{111}\xecnh v\u{1EDB}i kh\xf4ng khi ng\u{1ED9}t ng\u{1EA1}t, \u{111}\u{1EA7}y nh\u{1EEF}ng l\u{1EDD}i tr\xe1ch m\xf3c.<br />
  Su\u{1ED1}t m\u{1ED9}t th\u{1EDD}i gian d\xe0i, ch\u{1ECB} v\xe0 ch\u{1ED3}ng \u{111}\xe3 t\xecm m\u{1ECD}i c\xe1ch \u{111}\u{1EC3} c\u{1EE9}u v\xe3n, t\u{1EEB} c\xe1c cu\u{1ED9}c tr\xf2 chuy\u{1EC7}n \u{111}\u{1EBF}n c\xe1c gi\u{1EA3}i ph\xe1p c\u{1EA3}i thi\u{1EC7}n h\xf4n nh\xe2n, nh\u{1B0}ng t\u{1EA5}t c\u{1EA3} \u{111}\u{1EC1}u kh\xf4ng mang l\u{1EA1}i k\u{1EBF}t qu\u{1EA3}. \u{110}\u{1EBF}n khi v\u{1EE3} ch\u{1ED3}ng quy\u{1EBF}t \u{111}\u{1ECB}nh chia tay, ch\u{1ECB} m\u{1EDB}i nh\u{1EAD}n ra s\u{1EF1} thay \u{111}\u{1ED5}i \u{111}\u{1EBF}n \u{111}au l\xf2ng c\u{1EE7}a con g\xe1i: T\u{1EEB} m\u{1ED9}t h\u{1ECD}c sinh gi\u{1ECF}i, ho\u{1EA1}t b\xe1t, con tr\u{1EDF} n\xean s\u{1ED1}ng kh\xe9p k\xedn, thu m\xecnh v\xe0 m\u{1EA5}t k\u{1EBF}t n\u{1ED1}i \u{111}\xe1ng k\u{1EC3} v\u{1EDB}i m\u{1EB9}.<br />
  L\xfac \u{111}\xf3 ch\u{1ECB} ch\u{1EC9} c\xf3 m\u{1ED9}t khao kh\xe1t duy nh\u{1EA5}t l\xe0: T\xecm l\u{1EA1}i \u{111}\u{1EE9}a con t\u{1EEB}ng vui v\u{1EBB}, n\u{103}ng \u{111}\u{1ED9}ng nh\u{1B0} tr\u{1B0}\u{1EDB}c. V\xe0 ch\xednh trong kho\u{1EA3}nh kh\u{1EAF}c \u{1EA5}y, ch\u{1ECB} bi\u{1EBF}t \u{111}\u{1EBF}n c\xf4 Lanh v\xe0 b\u{1EAF}t \u{111}\u{1EA7}u nh\u{1EAD}n ra r\u{1EB1}ng v\u{1EA5}n \u{111}\u{1EC1} hi\u{1EC7}n t\u{1EA1}i c\u{1EE7}a m\xecnh kh\xf4ng ph\u{1EA3}i n\u{1EB1}m \u{1EDF} con hay ch\u{1ED3}ng, m\xe0 l\xe0 ch\u{1ECB} c\xf3 v\u{1EA5}n \u{111}\u{1EC1} v\u{1EDB}i ch\xednh b\u{1EA3}n th\xe2n m\xecnh.
        `,
        videoSrc: "https://cdn.nguyenthilanh.com.vn/resources/landing-page/NGUY\u1EC4N TH\u1ECA THU HUY\u1EC0N.mp4",
        thumb: $f7fca9471e720bd1$var$img5
    },
    {
        title: "M\u1EB9 \xe1p \u0111\u1EB7t l\xe0m t\u1ED5n th\u01B0\u01A1ng con",
        description: `
          Khi b\u{1B0}\u{1EDB}c v\xe0o \u{111}\u{1ED9} tu\u{1ED5}i d\u{1EAD}y th\xec, con trai c\u{1EE7}a ch\u{1ECB} Huy\u{1EC1}n Trang th\u{1B0}\u{1EDD}ng xuy\xean n\xf3ng n\u{1EA3}y v\xe0 kh\xf3 ki\u{1EC3}m so\xe1t c\u{1EA3}m x\xfac, c\u{169}ng nh\u{1B0} ch\u{1B0}a ch\u{1EE7} \u{111}\u{1ED9}ng trong h\u{1ECD}c t\u{1EAD}p v\xe0 cu\u{1ED9}c s\u{1ED1}ng. \u{110}i\u{1EC1}u n\xe0y khi\u{1EBF}n ch\u{1ECB} lo l\u{1EAF}ng v\xe0 b\u{103}n kho\u{103}n kh\xf4ng bi\u{1EBF}t l\xe0m sao \u{111}\u{1EC3} c\xf3 th\u{1EC3} d\u{1EAB}n d\u{1EAF}t con ph\xe1t tri\u{1EC3}n t\u{1ED1}t h\u{1A1}n.<br />
  Trong qu\xe1 tr\xecnh t\xecm ki\u{1EBF}m gi\u{1EA3}i ph\xe1p, ch\u{1ECB} \u{111}\xe3 bi\u{1EBF}t \u{111}\u{1EBF}n c\xf4 Lanh v\xe0 tham gia v\xe0o c\xe1c bu\u{1ED5}i chia s\u{1EBB} c\u{1EE7}a c\xf4, n\u{1A1}i ch\u{1ECB} \u{111}\u{1B0}\u{1EE3}c l\u{1EAF}ng nghe nh\u{1EEF}ng c\xe2u chuy\u{1EC7}n chuy\u{1EC3}n h\xf3a \u{111}\u{1EA7}y c\u{1EA3}m h\u{1EE9}ng c\u{1EE7}a c\xe1c kh\xe1ch h\xe0ng kh\xe1c. Kh\xf4ng ch\u{1EC9} d\u{1EEB}ng l\u{1EA1}i \u{1EDF} \u{111}\xf3, ch\u{1ECB} c\xf2n tham gia ch\u{1B0}\u{1A1}ng tr\xecnh Ki\u{1EBF}n t\u{1EA1}o offline, n\u{1A1}i ch\u{1ECB} th\u{1EF1}c h\xe0nh c\xe1c quy tr\xecnh \u{111}\u{1EA7}y quy\u{1EC1}n n\u{103}ng. Nh\u{1EDD} s\u{1EF1} ki\xean nh\u{1EAB}n v\xe0 \u{111}\u{1ED3}ng h\xe0nh, m\u{1ED1}i quan h\u{1EC7} gi\u{1EEF}a hai m\u{1EB9} con d\u{1EA7}n \u{111}\u{1B0}\u{1EE3}c c\u{1EA3}i thi\u{1EC7}n, con \u{111}\xe3 b\xecnh t\u{129}nh h\u{1A1}n v\xe0 c\xf3 nh\u{1EEF}ng thay \u{111}\u{1ED5}i t\xedch c\u{1EF1}c.<br />
  H\xe0nh tr\xecnh c\u{1EE7}a ch\u{1ECB} Huy\u{1EC1}n Trang kh\xf4ng ch\u{1EC9} gi\xfap con ph\xe1t tri\u{1EC3}n t\u{1ED1}t h\u{1A1}n m\xe0 c\xf2n l\xe0 ngu\u{1ED3}n \u{111}\u{1ED9}ng l\u{1EF1}c l\u{1EDB}n cho nh\u{1EEF}ng b\u{1EAD}c cha m\u{1EB9} \u{111}ang t\xecm ki\u{1EBF}m c\xe1ch th\u{1EE9}c \u{111}\u{1EC3} d\u{1EAB}n d\u{1EAF}t con c\xe1i m\u{1ED9}t c\xe1ch hi\u{1EC7}u qu\u{1EA3}.
        `,
        videoSrc: "https://cdn.nguyenthilanh.com.vn/resources/landing-page/PH\u1EA0M HUY\u1EC0N TRANG.mp4",
        thumb: $f7fca9471e720bd1$var$img6
    },
    {
        title: "Ui m\u1EB9 m\xe0y \u0111\xfang l\xe0 ng\u01B0\u1EDDi m\u1EB9 ao \u01B0\u1EDBc!",
        description: `
         "Ui m\u{1EB9} m\xe0y \u{111}\xfang l\xe0 ng\u{1B0}\u{1EDD}i m\u{1EB9} ao \u{1B0}\u{1EDB}c! - Con k\u{1EC3} l\u{1EA1}i v\u{1EDB}i m\xecnh nh\u{1B0} th\u{1EBF} khi \u{111}\u{1B0}\u{1EE3}c b\u{1EA1}n khen v\u{1EC1} m\u{1EB9}, l\xfac \u{111}\xf3 m\xecnh r\u{1EA5}t vui v\xe0 t\u{1EF1} h\xe0o." - Ch\u{1ECB} \u{110}\u{1EA1}t chia s\u{1EBB}.
L\xe0 m\u{1ED9}t ng\u{1B0}\u{1EDD}i m\u{1EB9} \u{111}\u{1A1}n th\xe2n v\u{1EDB}i ba con nh\u{1ECF}, ch\u{1ECB} \u{110}\u{1EA1}t \u{111}\xe3 g\u{1EB7}p kh\xf4ng \xedt kh\xf3 kh\u{103}n trong h\xe0nh tr\xecnh nu\xf4i d\u{1EA1}y con, nh\u{1EA5}t l\xe0 khi ph\u{1EA3}i \u{111}\u{1EA3}m nhi\u{1EC7}m c\u{1EA3} vai tr\xf2 c\u{1EE7}a cha l\u{1EAB}n m\u{1EB9}. Khi c\xe1c con ng\xe0y c\xe0ng l\u{1EDB}n, ch\u{1ECB} c\xe0ng ph\u{1EA3}i \u{111}\u{1ED1}i m\u{1EB7}t v\u{1EDB}i nhi\u{1EC1}u th\xe1ch th\u{1EE9}c: c\xe1c con tr\u{1EDF} n\xean l\u{1B0}\u{1EDD}i h\u{1ECD}c, thi\u{1EBF}u t\u{1EF1} gi\xe1c, th\u{1B0}\u{1EDD}ng b\u{1ECB} cu\u{1ED1}n v\xe0o game v\xe0 \u{111}i\u{1EC7}n tho\u{1EA1}i. M\u{1EB7}c d\xf9 ch\u{1ECB} khuy\xean r\u{103}n, nh\u{1EAF}c nh\u{1EDF} nh\u{1B0}ng l\u{1EDD}i n\xf3i c\u{1EE7}a ch\u{1ECB} kh\xf4ng c\xf2n t\xe1c \u{111}\u{1ED9}ng nhi\u{1EC1}u, khi\u{1EBF}n ch\u{1ECB} c\xe0ng th\xeam m\u{1EC7}t m\u{1ECF}i v\xe0 b\u{1EA5}t l\u{1EF1}c.
Trong qu\xe1 tr\xecnh t\xecm ki\u{1EBF}m gi\u{1EA3}i ph\xe1p, ch\u{1ECB} \u{111}\xe3 bi\u{1EBF}t \u{111}\u{1EBF}n c\xf4 Lanh v\xe0 tham gia c\xe1c bu\u{1ED5}i chia s\u{1EBB} c\u{1EE7}a c\xf4. T\u{1EA1}i \u{111}\xe2y, ch\u{1ECB} \u{111}\u{1B0}\u{1EE3}c nghe nh\u{1EEF}ng c\xe2u chuy\u{1EC7}n chuy\u{1EC3}n h\xf3a \u{111}\u{1EA7}y c\u{1EA3}m h\u{1EE9}ng c\u{1EE7}a c\xe1c kh\xe1ch h\xe0ng kh\xe1c. Kh\xf4ng ch\u{1EC9} d\u{1EEB}ng l\u{1EA1}i \u{1EDF} \u{111}\xf3, ch\u{1ECB} c\xf2n tham gia ch\u{1B0}\u{1A1}ng tr\xecnh Ki\u{1EBF}n t\u{1EA1}o offline, n\u{1A1}i ch\u{1ECB} th\u{1EF1}c h\xe0nh c\xe1c quy tr\xecnh \u{111}\u{1EA7}y quy\u{1EC1}n n\u{103}ng. Nh\u{1EDD} s\u{1EF1} ki\xean nh\u{1EAB}n v\xe0 \u{111}\u{1ED3}ng h\xe0nh, m\u{1ED1}i quan h\u{1EC7} gi\u{1EEF}a m\u{1EB9} con d\u{1EA7}n \u{111}\u{1B0}\u{1EE3}c c\u{1EA3}i thi\u{1EC7}n, c\xe1c con b\xecnh t\u{129}nh h\u{1A1}n v\xe0 c\xf3 nh\u{1EEF}ng thay \u{111}\u{1ED5}i t\xedch c\u{1EF1}c.`,
        videoSrc: "https://cdn.nguyenthilanh.com.vn/resources/landing-page/TR\u1ECANH TH\u1ECA \u0110\u1EA0T.mp4",
        thumb: $f7fca9471e720bd1$var$img7
    }
];
const $f7fca9471e720bd1$var$slideContentHighlight = [
    {
        title: "Ch\u01B0\u01A1ng Tr\xecnh Ki\u1EBFn T\u1EA1o Cu\u1ED9c \u0110\u1EDDi M\u1EDBi Offline K3 - \u0110\u01B0\u1EDDng V\u1EC1 H\u1EA1nh Ph\xfac th\xe1ng 10/2024",
        description: `
        ""
      `,
        videoSrc: "https://cdn.nguyenthilanh.com.vn/resources/landing-page/Ch\u01B0\u01A1ng Tr\xecnh Ki\u1EBFn T\u1EA1o Cu\u1ED9c \u0110\u1EDDi M\u1EDBi Offline K3 - \u0110\u01B0\u1EDDng V\u1EC1 H\u1EA1nh Ph\xfac th\xe1ng 10_2024.mp4",
        thumb: $f7fca9471e720bd1$var$thumbK3
    },
    {
        title: "Ch\u01B0\u01A1ng Tr\xecnh Ki\u1EBFn T\u1EA1o Cu\u1ED9c \u0110\u1EDDi M\u1EDBi Offline K2 - \u0110\u01B0\u1EDDng V\u1EC1 H\u1EA1nh Ph\xfac th\xe1ng 7/2024",
        description: `
        ""
      `,
        videoSrc: "https://cdn.nguyenthilanh.com.vn/resources/landing-page/Ch\u01B0\u01A1ng Tr\xecnh Ki\u1EBFn T\u1EA1o Cu\u1ED9c \u0110\u1EDDi M\u1EDBi Offline K2 - \u0110\u01B0\u1EDDng V\u1EC1 H\u1EA1nh Ph\xfac th\xe1ng 7_2024.mp4",
        thumb: $f7fca9471e720bd1$var$thumbK2
    },
    {
        title: "Ch\u01B0\u01A1ng Tr\xecnh Ki\u1EBFn T\u1EA1o Cu\u1ED9c \u0110\u1EDDi M\u1EDBi Offline K1 - \u0110\u01B0\u1EDDng V\u1EC1 H\u1EA1nh Ph\xfac th\xe1ng 3/2024",
        description: `
        ""
      `,
        videoSrc: "https://cdn.nguyenthilanh.com.vn/resources/landing-page/Ch\u01B0\u01A1ng Tr\xecnh Ki\u1EBFn T\u1EA1o Cu\u1ED9c \u0110\u1EDDi M\u1EDBi Offline K1 - \u0110\u01B0\u1EDDng V\u1EC1 H\u1EA1nh Ph\xfac th\xe1ng 3_2024.mp4",
        thumb: $f7fca9471e720bd1$var$thumbK1
    }
];
const $f7fca9471e720bd1$var$swiperWrapper = document.querySelector(".swiper-wrapper-experience");
document.addEventListener("DOMContentLoaded", ()=>{
    const initialContent = $f7fca9471e720bd1$var$slideContentExperience[0];
    document.getElementById("slide-title").textContent = initialContent.title;
    document.getElementById("slide-description").innerHTML = initialContent.description;
    document.getElementById("slide-bg").style.backgroundImage = `url(${initialContent.thumb})`;
});
let $f7fca9471e720bd1$var$selectSlideIndex = 0;
let $f7fca9471e720bd1$var$selectSlideIndex2 = 0;
const $f7fca9471e720bd1$var$swiper = new Swiper(".swiper1", {
    spaceBetween: 20,
    loop: true,
    on: {
        slideChange: (swiper)=>console.log(swiper, "1688"),
        slideNextTransitionEnd: function() {
            $f7fca9471e720bd1$var$selectSlideIndex++;
            const activeContent = $f7fca9471e720bd1$var$slideContentExperience[$f7fca9471e720bd1$var$selectSlideIndex % $f7fca9471e720bd1$var$slideContentExperience.length];
            document.getElementById("slide-bg").style.backgroundImage = `url(${activeContent.thumb})`;
            document.getElementById("slide-title").textContent = activeContent.title;
            document.getElementById("slide-description").innerHTML = activeContent.description;
            document.getElementById("videoPlayer2").src = activeContent.videoSrc;
        },
        slidePrevTransitionEnd: function() {
            $f7fca9471e720bd1$var$selectSlideIndex--;
            const activeContent = $f7fca9471e720bd1$var$slideContentExperience[$f7fca9471e720bd1$var$selectSlideIndex % $f7fca9471e720bd1$var$slideContentExperience.length];
            document.getElementById("slide-bg").style.backgroundImage = `url(${activeContent.thumb})`;
            document.getElementById("slide-title").textContent = activeContent.title;
            document.getElementById("slide-description").innerHTML = activeContent.description;
            document.getElementById("videoPlayer2").src = activeContent.videoSrc;
        }
    },
    navigation: {
        nextEl: ".my-swiper-button-next",
        prevEl: ".my-swiper-button-prev"
    },
    breakpoints: {
        1024: {
            slidesPerView: 4
        },
        0: {
            slidesPerView: 1
        }
    },
    speed: 600
});
const $f7fca9471e720bd1$var$openVideoBtn2 = document.getElementById("openVideoBtn2");
function $f7fca9471e720bd1$var$openVideoExperience() {
    $f7fca9471e720bd1$var$videoPlayer.play().catch((error)=>{
        console.error("Video auto-play failed:", error);
    });
    $f7fca9471e720bd1$var$modal2.classList.remove("hidden");
}
$f7fca9471e720bd1$var$openVideoBtn2.addEventListener("click", $f7fca9471e720bd1$var$openVideoExperience);
$f7fca9471e720bd1$var$slideContentExperience.forEach((slide, index)=>{
    const slideDiv = document.createElement("div");
    slideDiv.className = "swiper-slide";
    slideDiv.innerHTML = `
  <div class="flex flex-col items-center overflow-hidden w-full">
    <div data-target-index="${index}" class="w-full h-[174px] rounded-lg cursor-pointer img-experience bg-cover bg-no-repeat" style="background-image: url('${slide.thumb}');">

    </div>
    <div class="px-4 py-2 text-center text-sm lg:text-base font-semibold text-[#fafafa]">
      ${slide.title}
    </div>
  </div>
  `;
    slideDiv.addEventListener("click", (event)=>{
        const targetDiv = event.target.closest(".img-experience");
        if (targetDiv) {
            const dataIndex = targetDiv.getAttribute("data-target-index");
            const activeIndex = dataIndex;
            const activeContent = $f7fca9471e720bd1$var$slideContentExperience[activeIndex % $f7fca9471e720bd1$var$slideContentExperience.length];
            document.getElementById("slide-bg").style.backgroundImage = `url(${activeContent.thumb})`;
            document.getElementById("slide-title").textContent = activeContent.title;
            document.getElementById("slide-description").innerHTML = activeContent.description;
            document.getElementById("videoPlayer2").src = activeContent.videoSrc;
            $f7fca9471e720bd1$var$openVideoExperience();
        }
    });
    $f7fca9471e720bd1$var$swiperWrapper.appendChild(slideDiv);
});
const $f7fca9471e720bd1$var$swiperHighLight = new Swiper(".swiper2", {
    spaceBetween: 20,
    loop: true,
    on: {
        slideNextTransitionEnd: function() {
            $f7fca9471e720bd1$var$selectSlideIndex2++;
            const activeContent = $f7fca9471e720bd1$var$slideContentHighlight[$f7fca9471e720bd1$var$selectSlideIndex2 % $f7fca9471e720bd1$var$slideContentHighlight.length];
            document.getElementById("slide-bg-highlight").style.backgroundImage = `url(${activeContent.thumb})`;
            document.getElementById("slide-title-highlight").textContent = activeContent.title;
            document.getElementById("videoPlayer2").src = activeContent.videoSrc;
        },
        slidePrevTransitionEnd: function() {
            $f7fca9471e720bd1$var$selectSlideIndex2--;
            const activeContent = $f7fca9471e720bd1$var$slideContentHighlight[$f7fca9471e720bd1$var$selectSlideIndex2 % $f7fca9471e720bd1$var$slideContentHighlight.length];
            document.getElementById("slide-bg-highlight").style.backgroundImage = `url(${activeContent.thumb})`;
            document.getElementById("slide-title-hightlight").textContent = activeContent.title;
            document.getElementById("videoPlayer2").src = activeContent.videoSrc;
        }
    },
    navigation: {
        nextEl: ".my-swiper-button-next-highlight",
        prevEl: ".my-swiper-button-prev-highlight"
    },
    breakpoints: {
        1024: {
            slidesPerView: 3
        },
        0: {
            slidesPerView: 1
        }
    },
    autoplay: false,
    speed: 600
});
const $f7fca9471e720bd1$var$modal2 = document.getElementById("videoModal2");
const $f7fca9471e720bd1$var$openVideoBtnHighlight = document.getElementById("openVideoBtnHighlight");
const $f7fca9471e720bd1$var$videoPlayer = document.getElementById("videoPlayer2");
const $f7fca9471e720bd1$var$closeVideoBtn2 = document.getElementById("closeVideoBtn2");
function $f7fca9471e720bd1$var$openVideoHighlight() {
    $f7fca9471e720bd1$var$videoPlayer.play().catch((error)=>{
        console.error("Video auto-play failed:", error);
    });
    $f7fca9471e720bd1$var$modal2.classList.remove("hidden");
}
$f7fca9471e720bd1$var$openVideoBtnHighlight.addEventListener("click", $f7fca9471e720bd1$var$openVideoHighlight);
$f7fca9471e720bd1$var$closeVideoBtn2.addEventListener("click", ()=>{
    // Pause the video and clear the source when closing
    $f7fca9471e720bd1$var$videoPlayer.pause();
    // Hide the modal
    $f7fca9471e720bd1$var$modal2.classList.add("hidden");
});
const $f7fca9471e720bd1$var$swiperWrapperHighlight = document.querySelector(".swiper-wrapper-highlight");
$f7fca9471e720bd1$var$slideContentHighlight.forEach((slide, index)=>{
    const slideDiv = document.createElement("div");
    slideDiv.className = "swiper-slide";
    slideDiv.innerHTML = `
  <div class="flex flex-col items-center overflow-hidden w-full">
    <div data-target-index=${index} class="w-full h-[250px] rounded-lg cursor-pointer bg-cover img-highlight bg-no-repeat" style="background-image: url('${slide.thumb}');">

    </div>
    <div class="px-4 py-2 text-center text-sm lg:text-base font-semibold text-[#fafafa]">
      ${slide.title}
    </div>
  </div>
`;
    // slideDiv.addEventListener("click", () => {
    //   swiperHighLight.slideTo(index);
    // });
    slideDiv.addEventListener("click", (event)=>{
        const targetDiv = event.target.closest(".img-highlight");
        if (targetDiv) {
            const dataIndex = targetDiv.getAttribute("data-target-index");
            const activeIndex = dataIndex;
            const activeContent = $f7fca9471e720bd1$var$slideContentHighlight[activeIndex];
            document.getElementById("slide-bg-highlight").style.backgroundImage = `url(${activeContent.thumb})`;
            document.getElementById("slide-title-highlight").textContent = activeContent.title;
            document.getElementById("videoPlayer2").src = activeContent.videoSrc;
            $f7fca9471e720bd1$var$openVideoHighlight();
        }
    });
    $f7fca9471e720bd1$var$swiperWrapperHighlight.appendChild(slideDiv);
});
function $f7fca9471e720bd1$var$changeExperienceTab(tab) {
    const experienceContentElement = document.getElementById("experience-content");
    const highlightContentElement = document.getElementById("highlight-content");
    const experienceTab = document.getElementById("experience-tab");
    const highlightTab = document.getElementById("highlight-tab");
    if (tab === "experience") {
        experienceContentElement.classList.remove("hidden");
        highlightContentElement.classList.add("hidden");
        experienceTab.classList.add("active-tab");
        experienceTab.classList.remove("inactive-tab");
        highlightTab.classList.add("inactive-tab");
        highlightTab.classList.remove("active-tab");
    } else {
        const initialContent = $f7fca9471e720bd1$var$slideContentHighlight[0];
        document.getElementById("slide-title-highlight").textContent = initialContent.title;
        document.getElementById("slide-bg-highlight").style.backgroundImage = `url(${initialContent.thumb})`;
        document.getElementById("videoPlayer2").src = initialContent.videoSrc;
        experienceContentElement.classList.add("hidden");
        highlightContentElement.classList.remove("hidden");
        highlightTab.classList.add("active-tab");
        highlightTab.classList.remove("inactive-tab");
        experienceTab.classList.add("inactive-tab");
        experienceTab.classList.remove("active-tab");
    }
}
window.changeExperienceTab = $f7fca9471e720bd1$var$changeExperienceTab;


//# sourceMappingURL=bi_quyet_giup_con_het_nghien_game_tu_chuyen_gia_Nguyen_Thi_Lanh.70b8ac06.js.map
